import React from "react";

import ImageAtom, {
  MagnoliaImage,
} from "@/app/shared-components/image-wrapper/image";
import { useWizard } from "@/app/shared-providers/wizard-context-provider";
import { useDynamicTrustpilotText } from "@/hooks/use-dynamic-trustpilot-text/use-dynamic-trustpilot-text";

import { useTrustpilotBannerData } from "../../hooks/trustpilot-header-content.hooks";

function TrustpilotHeader() {
  const { data } = useTrustpilotBannerData();

  // Replace placeholders with dynamic Trustpilot data
  const dynamicTrustpilotText = useDynamicTrustpilotText(data?.trustpilotText);

  const { current } = useWizard();
  const showNewButtonsLayout = current.uiElementControls?.showNewButtonsLayout;

  const imageProps: MagnoliaImage | undefined | null =
    typeof data?.trustpilotImage === "string"
      ? {
          "@id": "",
          "@link": data?.trustpilotImage,
          "@name": "",
          "@path": "",
          "@type": "",
          "@uuid": "",
        }
      : data?.trustpilotImage;

  return (
    <div
      data-testid="trustpilot-wrapper"
      className={`w-full flex justify-between items-center ${
        showNewButtonsLayout
          ? "mx-0 max-w-none"
          : "mx-auto max-w-none md:max-w-[432px]"
      }`}
    >
      <div
        data-testid="trustpilot-text-container"
        className={`font-body-font text-[14px] leading-[21px] ${
          showNewButtonsLayout
            ? "mr-spacing-m flex-[1_0_0] min-w-0"
            : "lg:mr-spacing-m md:mr-spacing-l mr-spacing-m lg:max-w-none max-w-[261px] w-full"
        }`}
      >
        <p
          data-testid="paragaph-testid"
          className=" false"
          id="paragaph-test-id"
        >
          {dynamicTrustpilotText}
        </p>
      </div>
      <div
        data-testid="trustpilot-image-container"
        className={`max-w-[140px] w-full ${
          showNewButtonsLayout ? "shrink-0" : ""
        }`}
      >
        {imageProps && (
          <ImageAtom image={imageProps} clickableLink={data?.trustpilotUrl} />
        )}
      </div>
    </div>
  );
}

export default TrustpilotHeader;
